import { color, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Box from "../../../../Box/Box";
export const StepContainer = styled(Box) `
  min-height: ${spacing.base.xl};
  overflow: hidden;
  border-radius: ${size.borderRadius};

  &.prevPresent {
    margin-left: -16px;
  }

  svg {
    fill: ${color.background.input.default};
    flex-shrink: 0;
  }

  .textContentBox {
    background-color: ${color.background.input.default};
    display: inline-flex;
    align-items: center;
  }

  &.disabled {
    .textContent {
      color: ${color.font.label.default};
    }
  }

  &.active,
  &.lastActive {
    .textContent,
    .textContentBox {
      background-color: ${color.background.selectableBox.selected};
    }

    svg {
      fill: ${color.background.selectableBox.selected};
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RlcENvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1dpemFyZC9jb21wb25lbnRzL1dpemFyZEluZGljYXRvci9zdHlsZWQvU3RlcENvbnRhaW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQ0wsS0FBSyxFQUNMLElBQUksRUFDSixPQUFPLEdBQ1IsTUFBTSxnREFBZ0QsQ0FBQztBQUN4RCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEdBQUcsTUFBTSxxQkFBcUIsQ0FBQztBQUV0QyxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBO2dCQUN4QixPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7O21CQUVaLElBQUksQ0FBQyxZQUFZOzs7Ozs7O1lBT3hCLEtBQUssQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLE9BQU87Ozs7O3dCQUtsQixLQUFLLENBQUMsVUFBVSxDQUFDLEtBQUssQ0FBQyxPQUFPOzs7Ozs7O2VBT3ZDLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU87Ozs7Ozs7OzBCQVFiLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLFFBQVE7Ozs7Y0FJbkQsS0FBSyxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsUUFBUTs7O0NBR3BELENBQUMifQ==